<template>
  <button
    class="asahi-button"
    :class="getClassObject"
    :disabled="disabled"
    v-bind="$attrs" >
    <template v-if="type === 'success'">
      <img :src='tick' :class="{'rotate': rotateIcon}"/>
    </template>
    <slot></slot>
  </button>
</template>

<script>
import { defineComponent } from 'vue'
import tick from '@/assets/icons/library/tick.svg'
export default defineComponent({
  inheritAttrs: false,
  name: 'AsahiButton',

  props: {
    type: {
      type: String,
      default: 'primary'
    },
    rounded: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    rigid: {
      type: Boolean,
      default: false
    },
    rotateIcon: {
      type: Boolean,
      default: false
    },
    noWrapText: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      tick
    }
  },
  computed: {
    getClassObject () {
      return {

        primary: this.type === 'primary',
        secondary: this.type === 'secondary',
        secondaryVariant: this.type === 'secondaryVariant',
        tertiary: this.type === 'tertiary',
        success: this.type === 'success',
        plain: this.type === 'plain',
        white: this.type === 'white',
        resetFilter: this.type === 'resetFilter',
        favorite: this.type === 'secondary-favorite',
        circle: this.type === 'circle',
        remove: this.type === 'remove-icon',
        link: this.type === 'link',
        bicon: this.type === 'icon',
        padding: this.type === 'padding',
        fixed: this.type === 'fixed',
        roundedcorner: this.rounded,
        disabled: this.disabled,
        counter: this.type === 'counter',
        square: this.rigid,
        nowraptext: this.noWrapText,
        header: this.type === 'header'
      }
    }
  }
})
</script>

<style scoped lang='scss'>
button:focus {
  outline: none;
}
.asahi-button {
  display: flex;
  align-items: center;
  justify-content: center;

  border: none;
  color: white;
  padding: 10px 16px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  height: 42px;
  &.nowraptext {
    white-space: nowrap;
  }
  &.square {
    border-radius: 0;
  }
  &.secondary-border-none {
    background-color: transparent;
    border: none;
    color: $button-secondary-text-color;
    margin: 0 2px;

  }
}
.roundedcorner {
  border-radius:25px;
}

.primary {
  background-color: $button-primary-bg-color;
  color: $button-primary-text-color;
}
.header {
  background-color: $gold-header;
  color: $button-primary-text-color !important;
}

.primary:hover {
  background-color: $button-primary-hover-color;
  color: $button-primary-text-color;
}
.primary:focus{
  border: none;
}

.plain {
  background-color: $button-plain-bg-color;
  color: $button-plain-text-color;
  border: 2px solid $header-secondary-gray;
}

.resetFilter {
  background-color: transparent;
  color: $primary-gold;
  text-decoration: underline;
  border: none;
}

.resetFilter:hover {
  background-color: transparent;
  color: $primary-gold;
  text-decoration: underline;
  border: none;
}

.secondary {
  background-color: $button-secondary-bg-color;
  color: $button-secondary-text-color;
  border: 2px solid $button-secondary-border-color;
}

.secondaryVariant {
  background-color: $button-secondary-text-color;
  color: $primary-white;
  border: 2px solid $button-secondary-border-color;
}

.secondary:hover {
  background-color: $button-secondary-bg-color;
  color: $button-secondary-text-color;
}

.tertiary {
  background-color: $button-tertiary-bg-color;
  color: $button-tertiary-text-color;
}

.tertiary:hover {
  background-color: $button-tertiary-bg-color;
  color: $button-tertiary-text-color;
}

.success {
  background-color : $button-success-bg-color;
  color: $button-success-color;
  border: none;
}

.white {
  background-color: $button-white-bg-color;
  color: $button-white-text-color;
  border: 2px solid $button-white-border-color;
}

.resetFilter {
  background-color: transparent;
  color: $primary-gold;
  text-decoration: underline;
  border: none;
}

.resetFilter:hover {
  background-color: transparent;
  color: $primary-gold;
  text-decoration: underline;
  border: none;
}

.favorite {
  background-color: $button-favorite-bg-color;
  color: $button-favorite-text-color;
  border: 2px solid $button-favorite-border-color;
}

.disabled {
  cursor: not-allowed;
  background-color: $button-disabled-bg-color;
  color: $button-disabled-text-color;
}
.disabled:hover{
  background-color: $button-disabled-bg-color;
  color: $button-disabled-text-color;
}

.favorite {
  background-color: $button-favorite-bg-color;
  color: $button-favorite-text-color;
  border: 2px solid $button-favorite-border-color;
}

.link {
  background-color: $button-link-bg-color;
  color: $button-link-text-color;
  text-decoration: underline;
}

.success {
  background-color : $button-success-bg-color;
  color: $button-success-color;
  border: none;
}
.circle {
  width: 40px;
  height: 40px;
  background-color: $button-favorite-bg-color;
  color: $button-favorite-text-color;
  border: 2px solid $button-secondary-text-color;
  display: flex;
  align-items: center;
  border-radius: 100%
}
.rotate {
  transition: transform 0.3s ease;
  transform: rotate(180deg);
}
.bicon {
  background-color: $button-link-bg-color;
  color: $button-link-text-color;
  text-decoration: underline;
  margin:0px;
}
.padding {
  background-color: $button-link-bg-color;
  color: $button-link-text-color;
  text-decoration: underline;
  margin:0px;
  padding: 0px;
}
.fixed {
  background-color: $button-primary-bg-color;
  color: $button-primary-text-color;
  display: flex;
  width: 100px;
  justify-content: center;
}

.roundedcorner {
  border-radius:25px;
}

.disabled {
  cursor: not-allowed;
  background-color: $button-disabled-bg-color;
  color: $button-disabled-text-color;
}
.disabled:hover{
  background-color: $button-disabled-bg-color;
  color: $button-disabled-text-color;
}

.rotate {
  transition: transform 0.3s ease;
  transform: rotate(180deg);
}

.counter {
  :hover {
    background-color: transparent;
  }
}

</style>
